import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ITeachingSubjectItem } from '@app/account/shared/payment-checkout-wizard/payment-checkout-wizard.service';
import { ChangableComponent } from '@models/changable.component';
import { fromEvent, Observable, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

export interface IHorizontalScrollItem {
  value: string | number;
  title: string;
  route?: string[];
  native?: boolean;
}

@Component({
  selector: 'app-horizontal-scroll-menu',
  templateUrl: './horizontal-scroll-menu.component.html',
  styleUrls: ['./horizontal-scroll-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalScrollMenuComponent extends ChangableComponent implements AfterViewInit {
  @Input() type: 'link' | 'text' = 'text';
  @Input() public set scrollList(scrollList: IHorizontalScrollItem[]) {
    this._scrollList = scrollList;
    if (!this._value && !this._selected) {
      this._selected = scrollList[0];
    }
  }
  public get scrollList(): IHorizontalScrollItem[] {
    return this._scrollList;
  }
  @Input() public set value(value: string | number) {
    this._value = value;
    if (this.scrollList.length) {
      this._selected = this.scrollList.find((option) => option.value === value);
    }
  }

  @Output() selectItem = new EventEmitter<ITeachingSubjectItem>();
  @ViewChild('scrollContainer') scrollContainer: ElementRef;

  private _scrollList: IHorizontalScrollItem[] = [];
  private _value: string | number;
  private _selected: IHorizontalScrollItem;
  private mousewheel$: Observable<any>;
  private scrollLeft$ = this.register(new Subject<MouseEvent>());

  ngAfterViewInit() {
    this.mousewheel$ = fromEvent(this.scrollContainer.nativeElement, 'mousewheel');
    this.mousewheel$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (event) => {
        event.preventDefault();
        this.scrollLeft$.next(event);
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'OTHER-PROBLEM');
      },
    });

    this.scrollLeft$.pipe(debounceTime(50), takeUntil(this.destroyed$)).subscribe({
      next: (event) => this.onScroll(event),
      error: (error) => {
        this.errorNotificationService.captureError(error, 'OTHER-PROBLEM');
      },
    });
  }

  public isSelected(item: IHorizontalScrollItem): boolean {
    if (this._selected) {
      return this._selected.value === item.value;
    }
    return false;
  }

  public selectOption(item) {
    this._selected = item;
    this.selectItem.emit(item);
  }

  private onScroll(event) {
    const scrollLeft = this.scrollContainer.nativeElement.scrollLeft;
    this.scrollContainer.nativeElement.scrollLeft = scrollLeft + event.deltaY;
  }

  public trackByFn(index) {
    return index;
  }
}
